<template>
  <div class="user_management_background">
    <div class="user_title">用户管理</div>
    <div class="search_area">
      <el-form ref="form" :model="userSearchForm" label-width="11rem">
        <el-form-item class="search_item" label="注册日期：" label-width="12.4rem">
          <el-date-picker
            v-model="userSearchForm.date"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="年/月/日"
            end-placeholder="年/月/日"
            :picker-options="datePickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          class="search_item"
          label="用户手机号："
          label-width="13rem"
        >
          <el-input
            class="search_input"
            maxlength="11"
            placeholder="请输入用户手机号"
            v-model="userSearchForm.tel"
            @input="(v)=>{this.userSearchForm.tel = v.replace(/[^\d]/g,'')}"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item class="search_item" label="用户昵称：">
          <el-input
            class="search_input"
            maxlength="30"
            placeholder="请输入用户昵称"
            v-model.trim="userSearchForm.nickname"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item class="search_item" label="注册途径：">
          <el-select
            class="search_input"
            v-model="userSearchForm.source"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in sourceList"
              :label="item.areaName"
              :value="item.areaId"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item
          class="search_item"
          label="是否留有手机号："
          label-width="15.4rem"
        >
          <el-select
            class="search_input"
            v-model="userSearchForm.telState"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in stateList"
              :label="item.areaName"
              :value="item.areaId"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          class="search_item"
          label="是否登录过："
          label-width="12.3rem"
        >
          <el-select
            class="search_input"
            v-model="userSearchForm.loginState"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in stateList"
              :label="item.areaName"
              :value="item.areaId"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item
          class="search_item"
          label="专属客服："
          label-width="12.4rem"
        >
          <el-input
            class="search_input"
            maxlength="11"
            placeholder="请输入专属客服手机号"
            v-model="userSearchForm.adminEnterpriseMobile"
            @input="(v)=>{this.userSearchForm.adminEnterpriseMobile = v.replace(/[^\d]/g,'')}"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item class="search_item" label-width="3rem">
          <el-button
            class="search_button"
            type="primary"
            @click="search()"
            style="background-color: #4ea2ff; border-color: #4ea2ff"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="table_area_all">
      <div class="user_total">
        合计：<span class="user_total_number">{{ number }}</span>
      </div>

      <div class="table_area">
        <el-table :data="totalList">
          <el-table-column
            prop="createTime"
            label="注册日期"
            :width="26.0 * docFontSize"
          ></el-table-column>
          <el-table-column
            prop="openName"
            label="是否留有手机号"
            :width="20.0 * docFontSize"
          ></el-table-column>
          <el-table-column
            prop="tel"
            label="手机号"
            :width="25.0 * docFontSize"
          ></el-table-column>
          <!-- <el-table-column
            prop="openName"
            label="是否绑定微信"
            :width="20.0 * docFontSize"
          ></el-table-column> -->
          <el-table-column
            prop="nickname"
            label="用户昵称"
            :width="35.0 * docFontSize"
          ></el-table-column>
          <el-table-column
            prop="serviceAdminEnterpriseMobile"
            label="专属客服"
            :width="25.0 * docFontSize"
          ></el-table-column>
          <el-table-column
            prop="serviceAdminFriendText"
            label="是否添加好友"
          ></el-table-column>
          <!-- <el-table-column
            prop="sourceName"
            label="注册途径"
            :width="20.0 * docFontSize"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="loginStateName"
            label="是否登录过"
            :width="20.0 * docFontSize"
          ></el-table-column> -->
          <!-- <el-table-column label="关联纪念堂操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="showDetails(scope.row)"
                v-if="pms.details"
                >详情</el-button
              >
              <el-button type="text" @click="showLog(scope.row)">日志</el-button>
            </template>
          </el-table-column> -->
          <template slot="empty">
            <table-empty></table-empty>
          </template>
        </el-table>
      </div>

      <div class="page_area">
        <el-pagination
          :current-page.sync="pageManagement.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageManagement.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
        >
        </el-pagination>
      </div>
    </div>
    <el-drawer
      title="日志"
      :visible.sync="tableLog"
      direction="rtl"
      :size="drawarWidth"
      custom-class="drawer_change"
    >
      <div>
        <div class="search_area_log">
          <el-form ref="form" :model="userSearchForm" label-width="11rem">
            <el-form-item class="search_item" label="操作员：">
              <el-input
                class="search_input"
                maxlength="60"
                placeholder="请输入操作员名称"
                v-model="userSearchForm.coding"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item
              class="search_item"
              label="操作内容："
              label-width="14rem"
            >
              <el-input
                class="search_input"
                maxlength="60"
                placeholder="请输入操作内容"
                v-model="userSearchForm.coding"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item class="search_item" label="操作日期：">
              <el-date-picker
                :v-model="userSearchForm.date"
                type="daterange"
                range-separator="——"
                start-placeholder="年/月/日"
                end-placeholder="年/月/日"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item class="search_item" label-width="5.5rem">
              <el-button
                class="search_button"
                type="primary"
                @click="search"
                style="
                  background-color: #4ea2ff;
                  border-color: #4ea2ff;
                  margin-left: 50rem;
                "
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="log_number_all">
          合计：<span class="log_number_blue">{{ numberLog }}</span>
        </div>
        <div class="table_area_log">
          <el-table :data="totalList">
            <el-table-column
              prop="date"
              label="序号"
              :width="30.0 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="e"
              label="操作员"
              :width="30.0 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="d"
              label="操作内容"
              :width="30.0 * docFontSize"
            ></el-table-column>
            <el-table-column prop="d" label="操作日期"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      title="用户管理详情"
      :visible.sync="tableDetails"
      direction="rtl"
      :size="drawarWidth"
      custom-class="drawer_change"
      :wrapperClosable="false"
      :before-close="handleClose"
    >
      <div>
        <div class="user_details_title">基础信息</div>
        <div class="user_details_middle">
          <div class="middle_title">
            注册日期：<span class="middle_text">{{ createTime }}</span>
          </div>
          <div class="middle_title">
            手机号：<span class="middle_text">{{ tel }}</span>
          </div>
          <div class="middle_title">
            是否绑定微信：<span class="middle_text">{{ openid }}</span>
          </div>
          <div class="middle_title">
            用户性别：<span class="middle_text">{{ sex }}</span>
          </div>
          <div class="middle_title">
            用户昵称：<span class="middle_text">{{ nickname }}</span>
          </div>
          <div class="middle_title">
            注册途径：<span class="middle_text">{{ source }}</span>
          </div>
          <div class="middle_title">
            是否登录过：<span class="middle_text">{{ loginState }}</span>
          </div>
        </div>
        <div class="user_details_title_a">关联纪念堂及关系</div>
        <div class="table_area_log">
          <div class="table_area_log_a">
            <el-table :data="relationList">
              <el-table-column
                prop="createTime"
                label="纪念堂创建时间"
                :width="18.0 * docFontSize"
              ></el-table-column>
              <el-table-column
                prop="code"
                label="纪念堂编号"
                :width="24.0 * docFontSize"
              ></el-table-column>
              <el-table-column
                prop="userDmRelationName"
                label="与纪念堂关系"
                :width="20.0 * docFontSize"
              ></el-table-column>
              <el-table-column
                prop="userStateName"
                label="是否是主办人"
                :width="20.0 * docFontSize"
              ></el-table-column>
              <el-table-column
                prop="userCount"
                label="纪念堂人数"
              ></el-table-column>

              <!-- <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="unbindUser(scope.row.date)"
                  >解绑</el-button
                >
              </template>
            </el-table-column> -->
              <template slot="empty">
                <table-empty></table-empty>
              </template>
            </el-table>
          </div>
          <div style="height: 3rem"></div>
        </div>

        <!-- <div class="page_area">
          <el-pagination
            :current-page.sync="pageManagementA"
            layout="prev, pager, next, jumper"
            :total="pageManagementA.total"
            @current-change="handleCurrentChange"
            :page-size="10"
          >
          </el-pagination>
        </div> -->
      </div>
    </el-drawer>

    <el-dialog
      title="解绑"
      width="61rem"
      :visible.sync="unbindUserDialog"
      :close-on-click-modal="false"
      :before-close="handleUserClose"
    >
      <div class="dialog_body_message" style="margin-bottom: 3rem">
        <div class="phone_message_text">验证码：</div>
        <el-input
          class="phone_message"
          maxlength="60"
          placeholder="请输入验证码"
          v-model="message"
          clearable
        ></el-input>
        <el-button class="message_to_phone">发送验证码至用户手机</el-button>
      </div>

      <div slot="footer">
        <el-button
          style="width: 10rem; margin-right: 1.5rem"
          @click="dialogCancel()"
          class="btn_cancle_dialog"
          >取消</el-button
        >
        <el-button
          class="dialog_button"
          style="background-color: #4ea2ff; border-color: #4ea2ff"
          type="primary"
          @click="dialogSave()"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "./Mixins";
import TableEmpty from "../../../../components/TableEmpty.vue";
export default {
  components: { TableEmpty },
  mixins: [mixin],
  data() {
    return {
      datePickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date("2021-01-01")
          );
        },
      },
      numberLog: "XXXXXX条",
      tableDetails: false,
      tableLog: false,
      unbindUserDialog: false,
      message: "",

      createTime: "",
      tel: "",
      openid: "",
      sex: "",
      nickname: "",
      source: "",
      loginState: "",

      pms: {
        details: false,
      },
    };
  },
  computed: {
    drawarWidth() {
      let result = 130.0 * this.docFontSize;
      let percent = (result / document.body.clientWidth) * 100;
      return `${percent}%`;
    },
    number: {
      get: function () {
        return this.UserManagement.userManagement.number;
      },
    },
    userSearchForm() {
      return this.UserManagement.userManagement.userSearchForm;
    },
    sourceList() {
      return this.UserManagement.userManagement.sourceList;
    },
    totalList() {
      return this.UserManagement.userManagement.totalList;
    },
    // pageManagementA() {
    //   return this.UserManagement.userManagement.pageManagementA;
    // },
    pageManagement() {
      return this.UserManagement.userManagement.pageManagement;
    },
    stateList() {
      return this.UserManagement.userManagement.stateList;
    },
    relationList() {
      return this.UserManagement.userManagement.relationList;
    },
  },
  created() {
    //处理返回键
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function () {
      history.pushState(null, null, document.URL);
    });

    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    //详情
    //this.pms.details = pms["60300"].check;

    this.findUserList();
  },
  mounted() {
    this.setLeftMenuShow_M(true);
    this.setLeftMenuIndex_M(5);
  },
  methods: {
    search() {
      this.UserManagement.userManagement.pageManagement = {
        page: 1,
        size: 10,
        total: 0,
      };
      this.findUserList();
    },
    handleSizeChange(v) {
      console.log(v);
      this.UserManagement.userManagement.pageManagement.size = v;
      this.findUserList();
    },
    handleCurrentChange(v) {
      console.log(v);
      this.findUserList();
    },
    showDetails(v) {
      console.log(v);
      this.tableDetails = true;
      this.findById(v.id).then((res) => {
        console.log(res);
        this.createTime = res.data.createTime.substring(0, 10);
        this.tel = res.data.tel;
        this.openid = res.data.openid != undefined ? "是" : "否";
        this.sex = res.data.gender == 0 ? "男" : "女";
        this.nickname = res.data.nickname;
        if (res.data.source == 1) {
          this.source = "线下";
        } else if (res.data.source == 2) {
          this.source = "APP";
        } else {
          this.source = "小程序";
        }
        this.loginState = res.data.loginState == 1 ? "是" : "否";
        res.data.dmList.forEach((_t) => {
          let kt = _t.userState - 0;
          switch (kt) {
            case 0:
              _t.userStateName = "否";
              break;
            case 1:
              _t.userStateName = "是";
              break;
            default:
          }
        });
        this.UserManagement.userManagement.relationList = res.data.dmList;
      });
    },
    handleClose(done) {
      this.createTime = "";
      this.tel = "";
      this.openid = "";
      this.sex = "";
      this.nickname = "";
      this.source = "";
      this.loginState = "";
      this.UserManagement.userManagement.relationList = [""];
      done();
    },
    showLog(v) {
      this.tableLog = true;
    },
    unbindUser(v) {
      this.unbindUserDialog = true;
    },

    handleUserClose(done) {
      done();
    },
    dialogCancel() {
      this.unbindUserDialog = false;
    },
    dialogSave() {
      //this.unbindUserDialog = false;
      let userName = "ZGJS4444";
      let appShortName = "185 2565 4545 ";
      let htmlStr = `<div>确定将纪念堂<span style='color:#2C90FF;'>${userName}</span>与用户<span style='color:#4EA2FF;'>${appShortName}</span>进行解绑吗？</div>`;
      this.$confirm(htmlStr, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>

<style lang="stylus" scoped>
.user_management_background {
  width: 100%;
  height: 100%;
  background: #FFFFFF;

  .user_title {
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    padding-left: 30px;
    border-bottom: 1px solid #E9ECF3;
  }

  .search_area {
    margin-top: 20px;
    width: 100%;
    border-bottom: 1px solid #E9ECF3;
    height: 124px;
  }

  .search_item {
    float: left;
    height: 40px;
  }

  .search_item >>>.el-form-item__label {
    color: #040300;
  }

  .search_input >>>.el-input__inner {
    width: 220px;
  }

  .search_button {
    width: 100px;
  }

  .user_total {
    margin-left: 30px;
    height: 62px;
    line-height: 62px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
  }

  .user_total_number {
    font-size: 16px;
    font-weight: 500;
    color: #2C90FF;
  }

  .table_area_all {
    background-color: #fff;
    position: absolute;
    left: 3rem;
    bottom: 0;
    right: 3rem;
    top: 25rem;
    overflow: auto;
  }

  .table_area >>>.el-table__header thead {
    tr, th {
      background-color: #F7FAFF;
    }
  }

  .table_area {
    margin-left: 30px;
    margin-right: 30px;
  }

  .table_area >>> .cell {
    margin-left: 40px;
  }

  .page_area {
    padding-top: 15px;
  }

  .page_area >>> .el-input__inner {
    border: 1px solid #DCDFE6;
  }

  .page_area {
    height: 30px;
    padding-top: 35px;
    padding-bottom: 15px;

    .el-pagination {
      text-align: center;
    }

    .el-pagination__total {
      color: #333333;
      font-size: 12px;
    }
  }

  .search_area_log {
    margin-left: 30px;
    width: 1210px;
    border: 1px solid #CCD7EA;
    height: 124px;
    padding-top: 20px;
  }

  .log_number_all {
    height: 62px;
    line-height: 62px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    margin-left: 30px;
  }

  .log_number_blue {
    font-size: 16px;
    font-weight: 500;
    color: #2C90FF;
  }

  .table_area_log >>> .cell {
    margin-left: 80px;
  }

  .table_area_log {
    width: 1230px;
    background-color: #00000000;
    position: absolute;
    left: 30px;
    bottom: 0;
    right: 0;
    top: 30.6rem;
    overflow: auto;
  }

  .table_area_log_a {
    width: 1210px;
    // max-height : 700px;
    // overflow:auto;
  }

  .user_details_title {
    width: 1210px;
    height: 60px;
    background: #F1F4F9;
    border: 1px solid #CCD7EA;
    line-height: 60px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    margin-left: 30px;
    padding-left: 30px;
    box-sizing: border-box;
  }

  .user_details_title_a {
    margin-left: 30px;
    width: 1210px;
    height: 60px;
    background: #F1F4F9;
    border-top: 1px solid #CCD7EA;
    border-left: 1px solid #CCD7EA;
    border-right: 1px solid #CCD7EA;
    border-bottom: 1px solid #CCD7EA;
    line-height: 60px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    padding-left: 30px;
    box-sizing: border-box;
  }

  .user_details_middle {
    width: 1209px;
    margin-left: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    min-height: 80px;
    // line-height: 80px;
    border-left: 1px solid #CCD7EA;
    border-right: 1px solid #CCD7EA;
    border-bottom: 1px solid #CCD7EA;
    margin-bottom: 20px;
  }

  .middle_title {
    font-size: 14px;
    font-weight: 400;
    color: #949494;
    margin-left: 30px;
  }

  .middle_text {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    margin-left: 10px;
  }

  .btn_cancle_dialog {
    border: 1px solid #2C90FF;
    color: #2C90FF;
  }

  .dialog_body_message {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .phone_message {
    margin-right: 30px;
    width: 160px;
  }

  .phone_message_text {
    margin-right: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #040300;
  }

  .message_to_phone {
    color: #FFFFFF;
    background: #F66915;
  }
}
</style>

<style lang="stylus">
.drawer_change .el-drawer__header {
  font-size: 34px;
  font-weight: 500;
  color: #000000;
}

.drawer_change .el-drawer__close-btn {
  font-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/PartII/UserManagement/components/UserManagement.vue